export default __webpack_public_path__ + "static/media/pix.40e6db6c.svg";